<script setup lang="ts">
// types
import type { StrapiHeader } from '@ts-strapi/interfaces'
// hooks
import { useHeaderMobile } from '@composables/widgets/headers/header-mobile.hook'
// assets
import { faBars } from '@fortawesome/pro-solid-svg-icons'
// components
import { AppIcon } from '@UI/Icons/AppIcon'
import { BtnPrimary } from '@UI/Buttons/BtnPrimary'
import { BtnSecondary } from '@UI/Buttons/BtnSecondary'
import HeaderLogo from '@Widgets/Headers/HeaderLogo.vue'
import HeaderMobileDrawer from '@Widgets/Headers/HeaderMobileDrawer.vue'

defineOptions({
  name: 'HeaderMobile',
})

const props = defineProps<{
  data: StrapiHeader
}>()

const {
  refIsOpen,
  refIsScrolled,
  handleOpen,
  handleClose,
  handlePrimaryClick,
} = useHeaderMobile({
  primaryButton: () => props.data.primaryButton,
})
</script>

<template>
  <header
    class="header-mobile"
    :class="{ 'header-mobile--scrolled': refIsScrolled }"
  >
    <HeaderLogo
      class="header-mobile__logo"
      :logo="data.logo"
      :logo-mobile="data.logoMobile"
      :link="data.logoLink"
      mobile
    />

    <div class="header-mobile__right">
      <BtnPrimary
        v-if="data.primaryButton"
        class="header-mobile__cta"
        size="small"
        @click="handlePrimaryClick"
      >
        {{ data.primaryButton.label }}
      </BtnPrimary>

      <BtnSecondary
        color="gray"
        @click="handleOpen"
      >
        <AppIcon
          :icon="faBars"
          size="big"
        />
      </BtnSecondary>
    </div>

    <HeaderMobileDrawer
      :data="data"
      :is-open="refIsOpen"
      @click:close="handleClose"
    />
  </header>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Headers/HeaderMobile.scss" />
